export const environment = {
  production: true,
  dev: false,
  galleryUrl: 'ourpixo.com',
  bookingsBaseUrl: 'https://prod-api.pixomaticc.com/6',
  eventsBaseUrl: 'https://prod-api.pixomaticc.com/2',
  photosBaseUrl: 'https://prod-api.pixomaticc.com/3',
  usersBaseUrl: 'https://prod-api.pixomaticc.com/1',
  notificationsBaseUrl: 'https://prod-api.pixomaticc.com/5',
  paymentsBaseUrl: 'https://prod-api.pixomaticc.com/4',
  tokenHashSalt: 'tm&-L#~uNq*!x,S3ID*&X5_FCAV),jIR',
  // Bare host, validated at module load by assertBareHost. Identical to prod's
  // value here, so prod and old staging render exactly as before.
  mediaCdnDomain: 'media.pixomaticc.com',
  eventPhotoPrefix: 'EVNT',
  profilePhotoPrefix: 'PRFL',
  apiKey: 'e4d3c2ba1d3c6f5e4f52ba16',
  sentryDsn: 'https://f6871d433473c26265a33257e40b4c5e@o4505632836354048.ingest.sentry.io/4505635002974208',
  tracesSampleRate: 0.5,
  replaysSessionSampleRate: 0.5,
  replaysOnErrorSampleRate: 1.0,
  allowedHosts: ['*.a.ourpixo.com' ],
  // No DB policy: these builds keep the historical fallback. A build that must be
  // pinned to one cluster+database sets both (see src/db-target.ts).
  requiredDbName: undefined as string | undefined,
  requiredDbHost: undefined as string | undefined,
};
